<template>
  <section class="[ c-page-header o-wrapper o-wrapper--center ] o-page-row--medium">
    <page-title>
      <slot name="title"></slot>
    </page-title>
    <div class="u-flex-set u-flex--align-items-center u-flex--wrap c-page-header-inner">
      <div class="c-page-header__description" v-if="hasSlotData('description')">
        <slot name="description"></slot>
      </div>
      <div class="c-page-header__action" v-if="hasSlotData('action')">
        <slot name="action"></slot>
      </div>
    </div>
  </section>
</template>

<script>
  import PageTitle from '@/components/common/PageTitle';

  export default {
    components: {
      PageTitle,
    },
    methods: {
      hasSlotData(name) {
        if (name) {
          return this.$slots[name];
        }
        return this.$slots.default;
      },
    }
  }
</script>

<style lang="scss" scoped>

  // Import private settings & functions
  @import "~@/assets/scss/private";

  h1 {
    margin-bottom: em(2px) !important;
  }

  .c-page-header-inner {
    @include down($desktop) {
      display: block !important;
    }
  }

  .c-page-header__description {
    border-left: 2px solid $color-alpha;
    padding: em($global-spacing-unit) em($global-spacing-unit);
    margin-left: em($global-spacing-unit);
    max-width: em(600px);
  }

  .c-page-header__action {
    @include down($desktop) {
      width: 100%;
      margin-top: 1em;
      margin-left: 0 !important;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/common/PageHeader.vue